import OpacityPanel from "./OpacityPanel";

export default OpacityPanel;
